import React from 'react'

import QuestionEdit from '../Components/Page/Actions/QuestionEdit'

function HomeAddQuestion() {
  return (
    <div>
      <QuestionEdit/>
    </div>
  )
}

export default HomeAddQuestion